// extracted by mini-css-extract-plugin
module.exports = {"BundleSectionWrapper":"StaticBundle_BundleSectionWrapper__yPZzX","fadeInOpacity":"StaticBundle_fadeInOpacity__oONw0"};